import React from "react";
import { View, Text, StyleSheet, Font } from "@react-pdf/renderer";
import RobotoLight from "../../assets/fonts/Roboto/Roboto-Light.ttf";
import RobotoBold from "../../assets/fonts/Roboto/Roboto-Bold.ttf";

// ✅ Correct way to register fonts with different weights
Font.register({
  family: "Roboto",
  fonts: [
    { src: RobotoLight, fontWeight: "light" },
    { src: RobotoBold, fontWeight: "bold" },
  ],
});

const styles = StyleSheet.create({
  table: {
    width: "100%",
    borderCollapse: "collapse",
    marginBottom: 10,
    border: "2px solid #c3c1c1",
    borderBottom: "none",
  },
  row: {
    flexDirection: "row",
    // borderBottom: "2px solid #c3c1c1",
  },
  cellRow: {
    flexDirection: "row",
    borderBottom: "2px solid #c3c1c1",
  },
  cellHeader: {
    width: "50%",
    fontFamily: "Roboto",
    fontSize: 12,
    fontWeight: "bold",
    padding: 8,
    // border: "2px solid #c3c1c1",
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
    backgroundColor: "#ededed",
  },
  cell: {
    width: "50%",
    padding: 6,
    fontSize: 11,
    fontWeight: "light",
  },
});

const ContractPdfTable = ({ primary, secondary, data }) => {
  return (
    <View style={styles.table} wrap={false}>
      {/* Table Header */}
      <View style={styles.row}>
        <Text
          style={{ ...styles.cellHeader, borderRight: "2px solid #c3c1c1" }}
        >
          {primary}
        </Text>
        <Text
          style={{
            ...styles.cellHeader,
            textAlign: "center",
          }}
        >
          {secondary}
        </Text>
      </View>{" "}
      {data}
      {/* <View style={styles.cellRow}>
        <Text style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}>
          TEST
        </Text>
        <Text style={styles.cell}>TEST</Text>
      </View>
      <View style={styles.cellRow}>
        <Text style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}>
          TEST
        </Text>
        <Text style={styles.cell}>TEST</Text>
      </View>
      <View style={styles.cellRow}>
        <Text style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}>
          TEST
        </Text>
        <Text style={styles.cell}>TEST</Text>
      </View>
      <View style={styles.cellRow}>
        <Text style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}>
          TEST
        </Text>
        <Text style={styles.cell}>TEST</Text>
      </View>
      <View style={styles.cellRow}>
        <Text style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}>
          TEST
        </Text>
        <Text style={styles.cell}>TEST</Text>
      </View>
      <View style={styles.cellRow}>
        <Text style={{ ...styles.cell, borderRight: "2px solid #c3c1c1" }}>
          TEST
        </Text>
        <Text style={styles.cell}>TEST</Text>
      </View> */}
    </View>
  );
};

export default ContractPdfTable;
